import { defineStore } from 'pinia';
import { clearBodyLocks, lock, unlock } from 'tua-body-scroll-lock';

import { CountryCode } from '@/__generated__/storefront/graphql';

type ConfigStoreState = {
  countryCode: `${CountryCode}` | null;
  pointsMultiplier: number;
  graphqlHost: string | null;
  language: string;
  scrollableElements: HTMLElement[];
  lastSearch: string;
  minSearch: number;
};

export const useConfigStore = defineStore('config', {
  state: (): ConfigStoreState => ({
    countryCode: null,
    graphqlHost: null,
    language: 'en',
    scrollableElements: [],
    lastSearch: '',
    minSearch: 3,
    pointsMultiplier: 0
  }),
  getters: {
    calculatedPoints() {
      return (value: number): number => {
        // calculates points based on the points multiplier
        // takes product unit price in cents and returns the points calculated
        // we always round up to the next integer
        return Math.round((value * this.pointsMultiplier) / 100);
      };
    },
    isBodyScrollLocked(): boolean {
      return this.scrollableElements.length > 0;
    }
  },
  actions: {
    clearAllBodyScrollLocks() {
      clearBodyLocks();
    },
    lockBodyScroll(selector: string | null) {
      const element = selector
        ? document.querySelector<HTMLElement>(selector)
        : null;

      // Allow for elements with position:sticky with overflowType 'clip'
      lock(element, { overflowType: 'clip' });

      if (element) {
        this.scrollableElements.push(element);
      }
    },
    allowBodyScroll() {
      this.scrollableElements.forEach((el) => {
        unlock(el);
      });
      this.scrollableElements = [];
    }
  }
});
